<template>
      <b-jumbotron>
          <header class="header">
              <h1>Web Administrator Portal</h1>
              <h2>Login</h2>
          </header>
        <b-form class="main">  
          <b-form-group
                    horizontal
                    :label-cols="4"
                    breakpoint="sm"
                    label="Email:">
            <b-form-input id="email" type="email" v-model="email"></b-form-input>
          </b-form-group>
          <b-form-group
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Password:">
              <b-form-input id="password" type="password" v-model="password" v-on:keyup.enter="login"></b-form-input>
          </b-form-group>
        </b-form>

        <b-form-group class="button-group">
            <b-btn class="login-btn" variant="success" v-on:click="login">Login</b-btn>
            <b-btn class="return-btn" variant="primary" v-on:click="returntohome">Return to site</b-btn>
        </b-form-group>
      </b-jumbotron>
</template>

<script>
import firebase from '../Firebase'
import router from '../router/index.js'

export default {
    name: 'Login',
    data() {
        return {
            email: '',
            password: '',
        }
    },
    components: {
        
    },
    methods: {
        login() {
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
                function() {
                    router.push('/Dashboard')
                },
                function() {
                    alert('Error: Invalid login details - Please try again.')
                    router.go()
                }
            );
        },
        returntohome() {
            location.href='http://www.speysidefbgc.com';
        }
    }
}
</script>

<style scoped>
.jumbotron {
    margin: auto;
    width: 500px;
    height: auto;
}
h1 {
    display: block;
    font-size: 18pt;
    font-weight: bold;
    color: #62af52;
    margin-bottom: 10px;
}
h2 {
    display: block;
    font-size: 15pt;
    margin-bottom: 20px;
}
.button-group {
    margin-top: 30px;
    margin-bottom: -20px;
}
.login-btn {
    margin-top: -20px;
    margin-right: 20px;
    cursor: pointer;
}
.return-btn {
    cursor: pointer;
}
.header {
    margin-top: -20px;
    font-size: 15pt;
}
.subheader {
    margin-top: 5px;
    margin-bottom: 20px;
    font-size: 13pt;
}
</style>